export { default } from './ExpansionPanelSummary';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/ExpansionPanelSummary/index.js
// module id = 542
// module chunks = 2